import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../LanguageContext';

const Header = () => {
  const location = useLocation();
  const { language, toggleLanguage, t } = useLanguage();

  const isActive = (path) => location.pathname === path;

  const navItems = [
    { path: '/', labelKey: 'nav.home' },
    { path: '/services', labelKey: 'nav.programs' },
    { path: '/about', labelKey: 'nav.ourStory' },
    { path: '/contact', labelKey: 'nav.contact' }
  ];

  return (
    <>
      {/* Glass Navigation */}
      <nav className="fixed top-0 w-full h-[60px] md:h-[70px] bg-white/80 backdrop-blur-[20px] z-[2000] border-b border-black/5">
        <div className="max-w-[1200px] mx-auto px-[3%] md:px-[5%] h-full flex justify-between items-center">
          {/* Logo */}
          <Link to="/" className="flex items-center no-underline">
            <img
              src="/images/harvest-logo.png"
              alt="Harvest Logo"
              className="h-10 md:h-12 w-auto"
            />
          </Link>

          {/* Centered Navigation Links */}
          <div className="flex items-center gap-3 md:gap-8">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`text-xs md:text-sm font-medium no-underline transition-colors ${
                  isActive(item.path) ? 'text-brand-accent font-semibold' : 'text-brand-text hover:text-brand-accent'
                }`}
              >
                {t(item.labelKey)}
              </Link>
            ))}
          </div>

          {/* Language Toggle Button */}
          <button
            onClick={toggleLanguage}
            className="flex items-center gap-1 px-3 py-1.5 md:px-4 md:py-2 bg-brand-orange/10 hover:bg-brand-orange/20 text-brand-orange rounded-full text-xs md:text-sm font-medium transition-all duration-300"
            aria-label={language === 'en' ? 'Switch to Arabic' : 'Switch to English'}
          >
            <span className="hidden md:inline">{language === 'en' ? 'عربي' : 'English'}</span>
            <span className="md:hidden">{language === 'en' ? 'ع' : 'En'}</span>
          </button>
        </div>
      </nav>
    </>
  );
};

export default Header;
